// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
/**
 * 配置模版表 实体类
 * 配置模版表
 */
export class ConfigSettingTemplate extends BaseEntity {
  /** 名称 : 名称 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** 编码 : 编码(唯一) */
  private _code: string;

  /** 设置：编码 */
  public get code() {
    return this._code;
  }

  /** 获取：编码 */
  public set code(value: string) {
    this._code = value;
  }

  /** 内容 : 内容 */
  private _content: string;

  /** 设置：内容 */
  public get content() {
    return this._content;
  }

  /** 获取：内容 */
  public set content(value: string) {
    this._content = value;
  }

  /** 描述 : 描述 */
  private _descript: string;

  /** 设置：描述 */
  public get descript() {
    return this._descript;
  }

  /** 获取：描述 */
  public set descript(value: string) {
    this._descript = value;
  }

  constructor() {
    super();
    this._name = '';
    this._code = '';
    this._content = '';
    this._descript = '';
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ConfigSettingTemplate, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.code = element.code;
      this.content = element.content;
      this.descript = element.descript;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.code = json.Code;
    this.content = json.Content;
    this.descript = json.Descript;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.Code = this.code;
    json.Content = this.content;
    json.Descript = this.descript;
  }

  static Create(json: any): ConfigSettingTemplate {
    const configSettingTemplate = new ConfigSettingTemplate();
    configSettingTemplate.Deserialize(json);
    configSettingTemplate.json = json;
    return configSettingTemplate;
  }
}
